














import { Mixins, Component, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import { BreadcrumbData } from '@/entities/breadcrumb/Breadcrumb';

@Component
export default class Breadcrumb extends Mixins(BaseMixin) {
    @Prop()
    private readonly data!: BreadcrumbData;
}
